/*
 *             Copyright (c) 2016 - 2023, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x4112=['long','toLocaleTimeString','numeric','toLocaleDateString'];(function(_0x4ccd01,_0x411217){var _0x565dd8=function(_0x11a469){while(--_0x11a469){_0x4ccd01['push'](_0x4ccd01['shift']());}};_0x565dd8(++_0x411217);}(_0x4112,0x1a6));var _0x565d=function(_0x4ccd01,_0x411217){_0x4ccd01=_0x4ccd01-0x0;var _0x565dd8=_0x4112[_0x4ccd01];return _0x565dd8;};export function dateToPrettyFormat(_0x46df6d,_0x20823b){return _0x20823b[_0x565d('0x1')](_0x46df6d,{'month':_0x565d('0x2'),'day':_0x565d('0x0')})+',\x20'+_0x20823b[_0x565d('0x3')](_0x46df6d,{'hour':_0x565d('0x0'),'minute':_0x565d('0x0')});}